import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const check = async () => {
      const isAuth = await checkAuth();
      if (!isAuth) {
        // Déterminer la page de redirection en fonction du chemin actuel
        const path = window.location.pathname;
        if (path.startsWith('/client')) {
          navigate('/client/login');
        } else {
          navigate('/admin/login');
        }
      }
      setIsChecking(false);
    };
    check();
  }, [checkAuth, navigate]);

  if (isChecking) {
    return <div>Chargement...</div>;
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
